module.exports = __webpack_public_path__ + "static/img/property_1_easypaisa.77d200e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_easypaisa.png
// module id = WeHS
// module chunks = 1